const bodyMoistureMap = {
  body: [
    {
      name: 'Dry',
      dataKey: 'dry',
      image:
        'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/scalp-dry.svg?v=1734035640'
    },
    {
      name: 'Balanced',
      dataKey: 'balanced',
      image:
        'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/scalp-balanced.svg?v=1734035640'
    },
    {
      name: 'Very Dry',
      dataKey: 'very dry',
      image:
        'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/scalp-dry.svg?v=1734035640'
    }
  ]
};

export { bodyMoistureMap };
